import Seo from "@/components/Seo";
import { useLang, route } from "../i18n";
import { COMPANY } from "../data/config";
import PageHero from "../components/PageHero";
import { SectionHead } from "../components/SectionHead";
import { Reveal } from "../components/Reveal";
import { ButtonPrimary } from "../components/Buttons";
import FinalCta from "../components/FinalCta";
import { Check } from "lucide-react";

const Resources = () => {
  const { lang, t } = useLang();
  const r = t.resourcesPage;

  return (
    <>
      <Seo title={r.seo.title} siteName={COMPANY.name} description={r.seo.description} />
      <PageHero
        eyebrow={r.eyebrow}
        lines={[r.title]}
        copy={r.copy}
        breadcrumb={[{ label: t.nav.home, to: route(lang, "home") }, { label: t.nav.resources }]}
        testid="resources-hero"
      />

      <section className="bg-[#F4F0E8]" data-testid="resources-checklists">
        <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
          <SectionHead eyebrow={r.checklistTitle} tone="light" />
          <div className="mt-14 grid gap-6 lg:grid-cols-3">
            {r.checklists.map((list, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div className="h-full border border-[#171717]/12 p-8 sm:p-10">
                  <span className="text-3xl font-light text-[#C6A46A]">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="mt-4 text-lg font-light tracking-tight text-[#171717]">{list.t}</h3>
                  <ul className="mt-6 space-y-3">
                    {list.items.map((item, j) => (
                      <li key={j} className="flex items-start gap-3 text-sm leading-relaxed text-[#171717]/70">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#8a6f3e]" strokeWidth={1.5} />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <p className="mt-12 max-w-3xl border-l-2 border-[#C6A46A] pl-6 text-sm leading-relaxed text-[#171717]/70">
              {r.note}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#EEE9DF]">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
          <div className="flex flex-wrap items-center justify-between gap-8">
            <div className="max-w-xl">
              <h2 className="text-2xl font-light tracking-tight text-[#171717] sm:text-3xl">{r.ctaTitle}</h2>
              <p className="mt-4 text-sm leading-relaxed text-[#171717]/60">{r.ctaCopy}</p>
            </div>
            <ButtonPrimary to={route(lang, "contact")} testid="resources-cta" event="book_consultation_click">
              {t.nav.book}
            </ButtonPrimary>
          </div>
        </div>
      </section>

      <FinalCta />
    </>
  );
};

export default Resources;
